import { MeetingMessageInfoProps } from './components/MeetingMessageInfo';
import { MeetingRequestActionsProps } from './components/MeetingRequestActions';
import { MeetingRequestResponseEditorProps } from './components/MeetingRequestResponseEditor';
import { MeetingDetailsProps } from './components/MeetingDetails';
import { MeetingDetailsTimeProps } from './components/MeetingDetailsTime';
import { MeetingDetailsLocationProps } from './components/MeetingDetailsLocation';
import { MeetingRequestInfoProps } from './components/MeetingRequestInfo';
import { MeetingRequestConflictsProps } from './components/MeetingRequestConflicts';
import { MeetingRequestViewStateHost } from './store/schema/MeetingRequestViewState';
import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MeetingMessage", webpackPrefetch: true */ './lazyIndex')
);

// Export types and schema
export { MeetingRequestViewState } from './store/schema/MeetingRequestViewState';
export { MeetingRequestViewStateHost };
export { default as deleteMeetingMessage } from './actions/deleteMeetingMessage';
export {
    default as MeetingMessageActionEntrySource,
} from './store/schema/MeetingMessageActionEntrySource';

// Synchronous utilities
export { default as isMeetingMessage } from './utils/isMeetingMessage';
export { default as isMeetingRequest } from './utils/isMeetingRequest';
export { default as isMeetingResponse } from './utils/isMeetingResponse';
export { default as isMeetingCancellation } from './utils/isMeetingCancellation';

// Lazy-load actions
export const lazyInitializeMeetingRequestViewState = new LazyAction(
    lazyModule,
    m => m.initializeMeetingRequestViewStateAction
);

// Lazy-load components
export const MeetingMessageInfo = createLazyComponent(lazyModule, m => m.MeetingMessageInfo);
export const MeetingRequestActions = createLazyComponent(lazyModule, m => m.MeetingRequestActions);
export const MeetingCancellationInfo = createLazyComponent(
    lazyModule,
    m => m.MeetingCancellationInfo
);
export const MeetingActionButton = createLazyComponent(lazyModule, m => m.MeetingActionButton);
export const MeetingDetailsTime = createLazyComponent(lazyModule, m => m.MeetingDetailsTime);
export const MeetingDetailsLocation = createLazyComponent(
    lazyModule,
    m => m.MeetingDetailsLocation
);
export const MeetingRequestInfo = createLazyComponent(lazyModule, m => m.MeetingRequestInfo);

export const MeetingRequestResponseEditor = createLazyComponent(
    lazyModule,
    m => m.MeetingRequestResponseEditor
);

export const MeetingDetails = createLazyComponent(lazyModule, m => m.MeetingDetails);
export const MeetingRequestConflicts = createLazyComponent(
    lazyModule,
    m => m.MeetingRequestConflicts
);
export const EditEventLink = createLazyComponent(lazyModule, m => m.EditEventLink);
export const MeetingMessageSummary = createLazyComponent(lazyModule, m => m.MeetingMessageSummary);
export const PreviewSummary = createLazyComponent(lazyModule, m => m.PreviewSummary);
export const SenderSummary = createLazyComponent(lazyModule, m => m.SenderSummary);
export const CollapsedMeetingMessage = createLazyComponent(
    lazyModule,
    m => m.CollapsedMeetingMessage
);
export const MeetingIcon = createLazyComponent(lazyModule, m => m.MeetingIcon);

export {
    MeetingMessageInfoProps,
    MeetingRequestActionsProps,
    MeetingRequestResponseEditorProps,
    MeetingDetailsProps,
    MeetingDetailsTimeProps,
    MeetingDetailsLocationProps,
    MeetingRequestInfoProps,
    MeetingRequestConflictsProps,
};
